'use strict';

import React, { Fragment } from 'react'

import { CSSTransition, TransitionGroup } from 'react-transition-group'

import { capitalize } from '@root/utility'

import Layout from '@Layout/BackOffice'

export default class CustomQuoteCheckbox extends React.Component
{
	constructor (props)
	{
		super(props);

		this.state =
		{
			id: ++app.form_index
		};

		this.handleChange = this.handleChange.bind(this);
	}

	componentWillMount ()
	{
		const component = this, props = this.props, state = this.state;
	}

	componentDidMount ()
	{
		const component = this, props = this.props, state = this.state;

		const element = props.element;

		if (!props.data || !props.onChange) return;

		(element.data || []).forEach(function (option)
		{
			let checked = false, id = option.id, name;

			if (parseInt(option.id) == option.id)
			{
				id = element.id + '-' + option.id;
			}

			name = 'custom_quote[checkboxes][' + id + ']';

			checked = props.data['custom_quote[checkboxes][' + id + ']'] || false;

			props.onChange(null,
			{
				value: checked,
				name: name
			});
		});
	}

	handleChange (e)
	{
		const component = this, props = this.props;

		let data =
		{
			value: e.target.checked,
			name: e.target.name
		};

		if (props.onChange)
		{
			props.onChange(e, data);
		}
	}

	render ()
	{
		const component = this, props = this.props, state = this.state;

		const element = props.element;

		let editable = props.data ? true : false;

		let options = (element.data || []).map(function (option)
		{
			let checked = false, id = option.id, name;

			if (parseInt(option.id) == option.id)
			{
				id = element.id + '-' + option.id;
			}

			if (editable)
			{
				name = 'custom_quote[checkboxes][' + id + ']';
			}

			if (props.data)
			{
				checked = props.data['custom_quote[checkboxes][' + id + ']'] || false;
			}

			let output =
			(
				<div className="c-custom-quote-element c-custom-quote-element--checkbox"
					key={ id }>

					<label htmlFor={ id } className="c-custom-quote-element__label">
						{ option.name }
					</label>

					<input className="c-form__checkbox" type="checkbox" id={ id }
						checked={ checked }
						onChange={ component.handleChange } readOnly={ !props.editable }
						name={ name } />

					<label htmlFor={ id } className="c-custom-quote-element__cb"></label>

				</div>
			);

			return output;
		});

		if (options.length === 0) return null;

		var output =
		(
			<Fragment>
				<div className="c-custom-quote__cb-title">
					{ element.label }
				</div>

				{ options }
			</Fragment>
		);

		return output;
	}
}